import React from 'react';

import { ApplicationLayout as SharedApplicationLayout } from '@betterment/shared-components';

import NoticeCollection from '../../InAppMessages/GlobalNotices/NoticeCollection';
import { Notifications } from '../../notifications/Notifications';
import Sidebar from '../../sidebar/Sidebar';
import Footer from '../components-v2/footer/Footer';

interface RootProps {
  pageTitle: string;
}

const Root: React.FC<React.PropsWithChildren<RootProps>> = ({ children, pageTitle }) => (
  <SharedApplicationLayout>
    <SharedApplicationLayout.Sidebar>
      <Sidebar />
    </SharedApplicationLayout.Sidebar>
    <SharedApplicationLayout.Main pageTitle={pageTitle}>
      <SharedApplicationLayout.Banner>
        <NoticeCollection css={{ gridColumnStart: 2 }} />
        <Notifications css={{ gridColumnStart: 2, my: 'space.300' }} />
      </SharedApplicationLayout.Banner>
      {children}
      <SharedApplicationLayout.Footer>
        <Footer />
      </SharedApplicationLayout.Footer>
    </SharedApplicationLayout.Main>
  </SharedApplicationLayout>
);

const Header: React.FC<React.PropsWithChildren> = ({ children }) => (
  <SharedApplicationLayout.Header>{children}</SharedApplicationLayout.Header>
);

const Content: React.FC<React.PropsWithChildren> = ({ children }) => (
  <SharedApplicationLayout.Content>{children}</SharedApplicationLayout.Content>
);

export const ApplicationLayout = Object.assign(Root, {
  Header,
  Content,
});
